var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrometheusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#e6522c",
    d: "M 55.5,-0.5 C 61.1667,-0.5 66.8333,-0.5 72.5,-0.5C 100.978,4.97727 119.312,21.6439 127.5,49.5C 127.5,59.1667 127.5,68.8333 127.5,78.5C 120.167,103.833 103.833,120.167 78.5,127.5C 68.8333,127.5 59.1667,127.5 49.5,127.5C 21.1929,119.195 4.52627,100.528 -0.5,71.5C -0.5,66.5 -0.5,61.5 -0.5,56.5C 5.38374,24.9495 24.0504,5.94954 55.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfb",
    d: "M 70.5,36.5 C 71.1023,43.4833 71.769,43.8167 72.5,37.5C 72.3846,30.3454 74.5512,24.012 79,18.5C 79.3333,21.8333 79.6667,25.1667 80,28.5C 82.9235,34.0151 85.5902,39.6818 88,45.5C 89.5373,53.9709 88.3707,61.9709 84.5,69.5C 85,69.8333 85.5,70.1667 86,70.5C 91.7954,68.6681 97.6288,68.0014 103.5,68.5C 101.39,73.8877 98.3897,78.721 94.5,83C 74.1667,83.6667 53.8333,83.6667 33.5,83C 29.6727,78.5039 26.6727,73.5039 24.5,68C 29.7542,68.0144 34.9209,68.8477 40,70.5C 40.8333,70.1667 41.6667,69.8333 42.5,69.5C 39.8553,65.5695 38.1887,61.2362 37.5,56.5C 39.9563,45.1281 42.6229,33.7948 45.5,22.5C 50.1045,27.1347 52.2712,32.8014 52,39.5C 53.7176,35.6807 55.0509,31.6807 56,27.5C 56.1887,22.7492 56.8553,18.0826 58,13.5C 63.4509,4.96977 65.4509,5.63644 64,15.5C 67.3464,22.178 69.513,29.178 70.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f19881",
    d: "M 70.5,36.5 C 71.1667,36.8333 71.8333,37.1667 72.5,37.5C 71.769,43.8167 71.1023,43.4833 70.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8d3c9",
    d: "M 34.5,89.5 C 34.5,89.1667 34.5,88.8333 34.5,88.5C 54.5,88.5 74.5,88.5 94.5,88.5C 94.5,92.1667 94.5,95.8333 94.5,99.5C 94.1667,99.5 93.8333,99.5 93.5,99.5C 93.5,96.1667 93.5,92.8333 93.5,89.5C 73.8333,89.5 54.1667,89.5 34.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 34.5,89.5 C 54.1667,89.5 73.8333,89.5 93.5,89.5C 93.5,92.8333 93.5,96.1667 93.5,99.5C 73.8333,99.5 54.1667,99.5 34.5,99.5C 34.5,96.1667 34.5,92.8333 34.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2a794",
    d: "M 34.5,88.5 C 34.5,88.8333 34.5,89.1667 34.5,89.5C 34.5,92.8333 34.5,96.1667 34.5,99.5C 54.1667,99.5 73.8333,99.5 93.5,99.5C 93.8333,99.5 94.1667,99.5 94.5,99.5C 74.3402,100.497 54.0069,100.83 33.5,100.5C 33.1832,96.2984 33.5166,92.2984 34.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2a693",
    d: "M 81.5,107.5 C 76.0403,106.171 70.207,105.504 64,105.5C 57.793,105.504 51.9597,106.171 46.5,107.5C 45.596,106.791 45.2627,105.791 45.5,104.5C 57.8333,104.5 70.1667,104.5 82.5,104.5C 82.7373,105.791 82.404,106.791 81.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfb",
    d: "M 81.5,107.5 C 78.5533,115.739 72.5533,119.739 63.5,119.5C 55.0412,119.364 49.3745,115.364 46.5,107.5C 51.9597,106.171 57.793,105.504 64,105.5C 70.207,105.504 76.0403,106.171 81.5,107.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrometheusIcon);
export default __webpack_public_path__ + "static/media/PrometheusIcon.dbc77f41fb6f4f673d47c963223cea7c.svg";
export { ForwardRef as ReactComponent };